import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, Input, Output, EventEmitter, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';
import { StihlEventDayDTO } from '../../../models/stihl-event-dto';
import { EventDayService } from '../../../services/event-day.service';
import { DomSanitizer } from '@angular/platform-browser';
import { GalleryService } from 'src/app/services/gallery.service';
import { StihlGallerySearchFilter, StihlGalleryDataDTO } from 'src/app/models/stihl-gallery-dto';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/services/user.service';
import { PollService } from 'src/app/services/poll.service';
import { FileService } from 'src/app/services/file.service';
import { StihlUserDTO } from 'src/app/models/stihl-user-dto';
import { FormDataDTO } from 'src/app/models/form-data-dto';
import { StihlPollUserDTO } from 'src/app/models/stihl-poll-dto';
import { visibleContentAnimation } from 'src/app/animations';



@Component({
  selector: 'app-event-info',
  templateUrl: './events-info.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  animations: [ visibleContentAnimation ]
})

export class EventInfoComponent implements OnInit, AfterViewChecked {

  model: StihlEventDayDTO;
  // idData: string;
  galleries: StihlGalleryDataDTO[] = [];
  search: StihlGallerySearchFilter = new StihlGallerySearchFilter();
  pollFilled: boolean | null = false;
  loadedPoll = false;
  HTML_FORM;
  formData: FormDataDTO;
  formList: FormDataDTO[] = [];
  userPoll: StihlPollUserDTO;
  @Input() idData;
  @Output() closeGallery = new EventEmitter<boolean>();


  constructor(private route: ActivatedRoute,
    private eventDayService: EventDayService,
    private fileService: FileService,
    private changeRef: ChangeDetectorRef,
    private router: Router,
    private toastr: ToastrService,
    private galleryService: GalleryService,
    private userService: UserService,
    private pollService: PollService,
    private sanitizer: DomSanitizer) {
  }

  ngAfterViewChecked(): void { this.changeRef.detectChanges(); }

  ngOnChanges() {

    this.model = null;

    if (this.idData !== null && this.idData !== undefined) {

      this.eventDayService.get(this.idData).subscribe(resp => {

        this.model = resp;
        this.getPollUserFilled();

        this.search.Id = this.model.IdGalleryCrypted;

        if (this.model.IdGallery != null) {
          this.getGallery();
        }
      }, (err) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao recuperar os dados',
          text: 'Ocorreu um erro'
        });
      });
    }
  }
  ngOnInit() {
  }

  getGallery() {
    const that = this;
    that.galleryService.getStihlGalleryDataLst(this.search).subscribe(resp => {
      that.galleries = resp;
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });

    });
  }

  getPollUserFilled() {

    if (this.model.IdPoll != null && this.model.PollStatus == true) {

      this.pollService.getPollUserFilled(this.model.IdEventDay, this.model.IdPoll).subscribe(res => {

        this.pollFilled = res;

        if (!this.pollFilled) {
          this.getPollForm();
        }

      });

    } else {

      this.pollFilled = null;

    }

  }

  getPollForm() {

    this.pollService.get(this.model.IdPollCrypted).subscribe(
      (poll) => {

        this.fileService.getFileDataTextByUrl(poll.File.FileUri).subscribe(resp => {
          this.HTML_FORM = this.sanitizer.bypassSecurityTrustHtml(resp);
          this.loadedPoll = true;
        });
      },
      (error) => {
        Swal.fire({
          icon: 'error',
          title: 'Erro ao transferir o ficheiro',
          text: 'Ocorreu um erro',
        });
      }
    );
  }

  saveFormulario() {

    const that = this;
    const form = document.querySelector('form');
    Swal.fire({
      allowOutsideClick: false,
      icon: 'info',
      text: 'Aguarde por favor…',
    });
    Swal.showLoading();

    if (that.checkForm(form)) {

      const that = this;
      let deletedElements: FormDataDTO[] = [];

      Array.from(form.elements).forEach(function (element: HTMLFormElement) {

        if (element["type"] != 'button' && element["type"] != 'submit' && element["type"] != 'file' && element["type"] != 'hidden') {

          if (element["type"] == 'radio' || element["type"] == 'checkbox') {

            that.formData = new FormDataDTO(
              element.dataset["label"],
              element["type"],
              element["value"],
              element.id,
              element.className,
              element["checked"]
            );

          }

          else {

            that.formData = new FormDataDTO(
              element.dataset["label"],
              element["type"],
              element["value"],
              element.id,
              element.className
            );

          }

          that.formList.push(that.formData);
        }

      });


      deletedElements = that.formList.filter(x => x.SELECTED == false);
      deletedElements.forEach((elem, index) => {
        let element = this.formList.find((x) => x.ID == elem.ID);
        if (element != null) {
          let indice = this.formList.indexOf(element);
          this.formList.splice(indice, 1);
        }
      });

      this.userPoll = new StihlPollUserDTO();
      this.userPoll.Data = JSON.stringify(that.formList);
      this.userPoll.IdData = this.model.IdEventDay;
      this.userPoll.IdPoll = this.model.IdPoll;


      this.pollService.postPollUser(this.userPoll).subscribe(
        (res) => {
          Swal.close();
          this.toastr.success('O inquérito foi criado com sucesso');
          this.pollFilled = true;
        },
        (error) => {
          Swal.fire({
            icon: 'error',
            title: 'Erro ao criar o pedido',
            text: 'Ocorreu um erro',
          });
        }
      );
    } else {
      Swal.close();
    }
  }

  checkForm(frm: HTMLFormElement) {
    const form = frm;
    if (form.checkValidity()) {
      return true;
    } else {
      Array.prototype.forEach.call(form.elements, function (element) {
        if (
          element["type"] != 'button' &&
          element["type"] != 'submit' &&
          element.validity.valid == false
        ) {
          element.className = element.className + ' ng-invalid is-invalid';
        }
      });
      return false;
    }
  }

  CloseGallery() {
    this.galleries = [];
    this.closeGallery.emit(false);
  }

  goToUrl() {
    window.open('http:/' + this.model.Url);
  }
}
